<template>
  <div class="score-entry-grade">
    <div class="select">
      <span style="margin-right: 5px; font-weight: bold">选择年级</span>
      <el-select
        v-model="selectGradeVal"
        placeholder="请选择"
        style="margin-left: 30px"
      >
        <el-option
          v-for="item in classSelectList"
          :key="item.gradeId"
          :label="item.gradeName"
          :value="item.gradeId"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 上传模块 -->
    <div class="upload-module">
      <div class="module-title">上传XLSX表格</div>
      <el-upload
        :on-change="onChange"
        class="upload-demo"
        drag
        :show-file-list="false"
        action="https://jsonplaceholder.typicode.com/posts/"
        multiple
        :auto-upload="false"
        accept=".xls,.xlsx"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <!-- 预览模块 -->
    <!-- <div class="preview-module">
      <div class="module-title">预览</div>
      <div class="preview-table">
        <el-table
          ref="multipleTable"
          tooltip-effect="dark"
          style="max-width: 650px; overflow: auto"
          :data="tableData"
        >
          <el-table-column label="#" type="index"> </el-table-column>
          <el-table-column prop="studentName" label="姓名" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="studentNumber"
            label="学号"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            :label="item.courseName"
            :prop="item.courseName"
            v-for="(item, index) in standardCourse"
            :key="index"
          >
          </el-table-column>
        </el-table>
      </div>
    </div> -->
    <!-- 确认上传到服务器 -->
    <div class="confirm-module">
      <div class="submit-button">
        <el-button type="primary" plain @click="back">返回</el-button>
        <el-button
          type="primary"
          :loading="submitButtonLoading"
          @click="upload"
          >{{ submitButtonLoading ? "录入中" : "确认录入" }}</el-button
        >
        <el-button type="primary" @click="uploadXlsxModule">下载模版</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: ["classSelectList", "isChooseContainerShow", "searchInfo"],
  data() {
    return {
      standard: [
        {
          label: "姓名",
          field: "studentName",
        },
        {
          label: "学号",
          field: "studentNumber",
        },
      ],
      standardCourse: [],
      submitButtonLoading: false,
      // tableData: [],
      courseName: "",
      formData: "", // 上传参数
      file: "", // 文件
      selectGradeVal: "", // 选中的年级
    };
  },
  mounted() {
    // this.standardCourse = this.courseList;
  },
  methods: {
    // 下载模板
    uploadXlsxModule() {
      if (this.selectGradeVal == "") return this.$message.warning("请选择年级");
      let action = `${baseURL}${this.$url.gradeDownElectiveGradeExcelPC}/${this.user.schoolId}/${this.selectGradeVal}`;
      window.open(action);
    },
    // 返回选择录入方式
    back() {
      this.$emit("update:isChooseContainerShow", true);
    },
    onChange(file, fileList) {
      // console.log(file);
      let file_type = file.name.split(".")[1];
      if (!/^(xls|xlsx)$/g.test(file_type)) {
        return this.$message.error("只能选择xlsx或xls类型文件");
      } else {
        //是xlsx，xls文件,读取文件数据
        this.$message.success("上传表格成功");
        this.file = file.raw;
        this.readFileData(file.raw, (workbook) => {
          this.readWorkbook(workbook);
        });
      }
    },
    readFileData(file) {
      const fileReader = new FileReader();
      // console.log(fileReader);
      // console.log("XLSX==>", XLSX);
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // console.log(ws);
          // this.achievementPreviewTableInit(ws);
        } catch (e) {
          console.log("生成表格报错==>", e);
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    // achievementPreviewTableInit(unmodifiedTableData) {
    //   // console.log("unmodifiedTableData==>", unmodifiedTableData);
    //   // console.log("this.standard==>", this.standard, this.standardCourse);
    //   this.tableData = [];
    //   unmodifiedTableData.forEach((item, index) => {
    //     let template = {};
    //     for (let standardItem of this.standard) {
    //       template[standardItem.field] = item[standardItem.label];
    //     }

    //     // 获取除了"姓名"和"学号"之外的属性名
    //     const propertyNames = Object.keys(item).filter(
    //       (propertyName) => propertyName !== "姓名" && propertyName !== "学号"
    //     );

    //     // 将属性名添加到this.standardCourse中，并去重
    //     for (let propertyName of propertyNames) {
    //       if (
    //         !this.standardCourse.some(
    //           (courseItem) => courseItem.courseName === propertyName
    //         )
    //       ) {
    //         this.standardCourse.push({ courseName: propertyName });
    //       }
    //     }

    //     for (let courseItem of this.standardCourse) {
    //       // console.log("courseItem==>", courseItem);
    //       template[courseItem.courseName] = item[courseItem.courseName];
    //     }
    //     this.tableData.push(JSON.parse(JSON.stringify(template)));
    //   });
    //   // console.log("this.tableData==>", this.tableData);
    // },
    // 上传
    upload() {
      if (this.file == "") {
        return this.$message.error("请添加数据");
      }
      if (this.submitButtonLoading) {
        return this.$message("录入中，请勿重复点击");
      }
      this.submitButtonLoading = true;
      this.formData = new FormData();
      this.formData.append("file", this.file);
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem(
            "bbfAdminTeacherToken"
          ),
          "Content-Type": "multipart/form-data",
        },
      };
      let action = `${baseURL}${this.$url.uploadGradeUpElectiveGrade}/${this.searchInfo.schoolYear}/${this.searchInfo.semester}`;
      axios
        .post(action, this.formData, config)
        .then((res) => {
          // res.data 服务器返回的数据
          let data = res.data;
          // console.log(data);
          if (res.status != 200) {
            this.$message.error("录入失败");
          } else {
            if (data.code == 200) {
              this.$message.success("录入成功");
              this.$emit("uploadGradeSuccess");
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error("录入失败");
            }
          }
          this.submitButtonLoading = false;
        })
        .catch((err) => {
          this.submitButtonLoading = false;
          this.$message.error("录入失败，请稍后再试");
        });
    },
    reset() {
      // this.tableData = [];
      this.formData = "";
      this.file = "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./scoreEntryGrade.scss";
</style>
